import { PORTFOLIO_GROWTH_FILTER_TYPE } from './PerformancePageSelectors';
import { BaseFilterReducer } from './BaseFilterReducer';

export const PortfolioGrowthFilterReducer = BaseFilterReducer(
  PORTFOLIO_GROWTH_FILTER_TYPE
);
